/* Barra secondaria: link admin / docente / supervisore / status in base al ruolo. */
(function () {
    var context = null;

    async function readGhostMemberSessionJwt() {
        try {
            var res = await fetch('/members/api/session/', { method: 'GET', credentials: 'include', cache: 'no-store' });
            if (res.status === 204 || !res.ok) return null;
            var text = (await res.text()).trim();
            if (!text) return null;
            if (text[0] === '{') {
                try {
                    var parsed = JSON.parse(text);
                    var nested = parsed.token || parsed.jwt;
                    if (typeof nested === 'string') text = nested.trim();
                } catch (e) { /* ignore */ }
            }
            text = text.replace(/^["']|["']$/g, '');
            if (text.split('.').length === 3) return text;
            return null;
        } catch (e2) {
            return null;
        }
    }

    /** Pagine sito (non /play): lascia la modalità gioco così dashboard/admin vedono Ghost. */
    async function clearPlaySession() {
        try {
            window.localStorage.removeItem('paperverso_token');
        } catch (e) { /* ignore */ }
        try {
            await fetch('/api/auth/clear-play-session', {
                method: 'POST',
                credentials: 'include',
                cache: 'no-store',
            });
        } catch (e2) { /* ignore */ }
    }

    async function loadContext() {
        if (context) return context;
        var headers = {};
        var jwt = await readGhostMemberSessionJwt();
        if (jwt) headers.Authorization = 'GhostMember ' + jwt;
        var res = await fetch('/api/auth/site-nav', {
            method: 'GET',
            credentials: 'include',
            headers: headers,
            cache: 'no-store',
        });
        if (!res.ok) return null;
        var data = await res.json();
        if (!data || !data.ok) return null;
        context = data;
        return context;
    }

    function t(key) {
        if (window.YOBY_i18n && typeof window.YOBY_i18n.t === 'function') {
            return window.YOBY_i18n.t(key);
        }
        return key;
    }

    function isPathActive(href) {
        var current = (window.location.pathname || '/').replace(/\/$/, '') || '/';
        var target = (href || '/').split('#')[0].replace(/\/$/, '') || '/';
        return current === target || current.indexOf(target + '/') === 0;
    }

    function linksForContext(ctx) {
        if (ctx.isAdmin) {
            return [
                { href: '/conference/', key: 'nav.staff.conference' },
                { href: '/admin-school/', key: 'nav.staff.admin' },
                { href: '/massmail/', key: 'nav.staff.massmail' },
                { href: '/teacher/', key: 'nav.staff.teacher' },
                { href: '/supervisor/', key: 'nav.staff.supervisor' },
                { href: '/status/', key: 'nav.staff.status' },
                { href: '/admin-safety/', key: 'nav.staff.adminSafety' },
                { href: '/redteam/', key: 'nav.staff.redteam' },
            ];
        }
        if (ctx.schoolRole === 'teacher') {
            return [{ href: '/teacher/', key: 'nav.staff.teacher' }];
        }
        if (ctx.schoolRole === 'supervisor') {
            return [{ href: '/supervisor/', key: 'nav.staff.supervisor' }];
        }
        return [];
    }

    function render() {
        var nav = document.getElementById('yoby-staff-nav');
        var ul = document.querySelector('[data-yoby-staff-nav="links"]');
        if (!nav || !ul || !context) return;

        var links = linksForContext(context);
        if (!links.length) {
            nav.classList.add('hidden');
            return;
        }

        ul.innerHTML = '';
        links.forEach(function (item) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.setAttribute('href', item.href);
            a.setAttribute('data-yoby-href-canonical', item.href);
            a.textContent = t(item.key);
            if (isPathActive(item.href)) {
                a.classList.add('nav-current');
                a.setAttribute('aria-current', 'page');
            }
            li.appendChild(a);
            ul.appendChild(li);
        });

        nav.setAttribute('aria-label', t('nav.aria.staff'));
        nav.classList.remove('hidden');
    }

    async function init() {
        await clearPlaySession();
        var ctx = await loadContext();
        if (!ctx || (!ctx.isAdmin && !ctx.schoolRole)) return;
        render();
    }

    window.YOBY_StaffNav = {
        refresh: render,
        init: init,
    };

    document.addEventListener('DOMContentLoaded', function () {
        void init();
    });
})();
